// extracted by mini-css-extract-plugin
module.exports = {"links":"footer-links-list_links__aULxR","link":"footer-links-list_link__oUmNQ"};